import "./ArrowButton.css"; // réutilise le style .arrow-btn
import { Info } from "lucide-react"; // ou utiliser un simple "i" si lucide non souhaité

const InfoButton = ({ onClick, color, isSelected }) => (
    <button
        className="arrow-btn info-btn"
        onClick={(e) => {
            e.stopPropagation();
            e.nativeEvent.isArrowClick = true;
            onClick && onClick();
        }}
        style={{
            backgroundColor: color,
            color: "var(--colorFront)",
            borderColor: "var(--colorFront)",
            borderRight: "2px",
            //borderColor: "var(--colorFront)"
        }}
        title="Info"
        type="button"
    >
        {/* si lucide-react n'existe pas, remplacez par un 'i' */}
        <Info size={16} strokeWidth={2.5} />
    </button>
);

export default InfoButton;


/** style={{
            backgroundColor: isSelected ? "var(--colorFront)" : color,
            color: isSelected ? "var(--colorBack)" : "var(--colorFront)",
            borderColor: "var(--colorFront)",
        }} */